import React from 'react';
import { ChevronRight } from 'lucide-react';
import { WORKY_WEB_APP_PATHS } from '../../WorkyWebAppPaths';
import { OperationsProductKey } from '../Pages/operationsProductCatalog';

const OPERATIONS_PRODUCT_LANDING_PATH: string = WORKY_WEB_APP_PATHS.landingPageOperations;

const OPERATIONS_PRODUCT_KEY_TO_SECTION_ID: Readonly<Partial<Record<OperationsProductKey, string>>> = {
    [OperationsProductKey.INVOICES]: 'invoicing',
    [OperationsProductKey.SCHEDULE]: 'smart-match',
    [OperationsProductKey.WORKFORCE]: 'workforce',
    [OperationsProductKey.CLOCK]: 'time-clock',
    [OperationsProductKey.PAY]: 'worky-pay',
    [OperationsProductKey.TRUST_VAULT]: 'trust-vault',
};

const getOperationsProductSectionLink = (productKey: OperationsProductKey): string => {
    const sectionId: string | undefined = OPERATIONS_PRODUCT_KEY_TO_SECTION_ID[productKey];
    if (!sectionId) {
        return OPERATIONS_PRODUCT_LANDING_PATH;
    }
    return `${OPERATIONS_PRODUCT_LANDING_PATH}#${sectionId}`;
};

const navigateToOperationsProductPage = (): void => {
    window.location.assign(OPERATIONS_PRODUCT_LANDING_PATH);
};

interface PushToOperationsProductPageProps {
    readonly isMobile: boolean;
    readonly children?: React.ReactNode;
}

const PushToOperationsProductPage = ({
    isMobile,
    children,
}: PushToOperationsProductPageProps): React.ReactElement => {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        navigateToOperationsProductPage();
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={isMobile ? 'lp-product-nav-button-mobile' : 'lp-product-nav-button'}
        >
            {children ?? <ChevronRight size={isMobile ? 18 : 20} />}
        </button>
    );
};

export {
    OPERATIONS_PRODUCT_LANDING_PATH,
    getOperationsProductSectionLink,
    navigateToOperationsProductPage,
    PushToOperationsProductPage,
};
